<template>
    <div class="us_app">
        <Gnb :isLogin="true" />
        <section class="user_section">
            <UserLnb :navTitle="getNavTitle" />
            <slot></slot>
        </section>
        <Footer />
    </div>
</template>

<script>
    import Gnb from "@/components/user/UserGnb.vue"
    import UserLnb from "@/components/user/UserLnb.vue"
    import Footer from "@/components/user/UserFooter.vue"

export default {
  name: "userLayout",
  components: {
    Gnb,
    UserLnb,
    Footer    
  },
  data() {
            return {
               title : '',
               firstTitle : '',
               layoutTile : '' 
            }
  },
  computed: {
    getNavTitle: function () {
        
        // console.log("@@@@ getNavTitle title : "+this.title);
        // console.log("@@@@ getNavTitle firstTitle : "+this.firstTitle);
        // console.log("@@@@ meta title : "+this.$route.meta.title);

        // Layout lnb 타이틀처리
        if(this.firstTitle != this.$route.meta.title){            
            this.title = this.$route.meta.title;
            this.firstTitle = this.$route.meta.title;
        }else if(this.title == ''){
            this.title = this.firstTitle;
        }

        let navList = [];
        navList.push(this.title);

        return navList;
        },
    },
    created(){
        this.firstTitle = this.$route.meta.title;
    }
};
</script>


